/**
 * Code Generators — per-API re-export hub.
 *
 * Each API the demo can export against (chat/completions today; detect, … later)
 * owns its own config type + generators under its own subfolder. This barrel
 * re-exports them per-API; there is intentionally no cross-API `generateCode`
 * switch — a consumer picks the API it targets (e.g. `generateChatCompletionsCode`).
 */

export * as chatCompletions from "./chatCompletions";

export { generateChatCompletionsCode } from "./chatCompletions";
export type {
  ContentItem,
  ExportCodeConfig,
  ExportLanguage,
  ImageContent,
  OutputFormat,
  TextContent,
  VideoContent,
} from "./chatCompletions";

export * as detect from "./detect";

export { generateDetectCode } from "./detect";
export type { DetectExportConfig, DetectExportLanguage, DetectOutput } from "./detect";
